/*
    描述 ：知识图谱平台用到的配置信息
    创建人：李珊 
    创建时间：2019-10-30
*/
export class KmsEnum{
    // 文件策略
    static KMS_INSTANCE_RESOURCE = 'KMS_INSTANCE_RESOURCE';           // 实体媒体资源(所有类型：文档、图像、音频、视频)
    static KMS_INSTANCE_IMG_RESOURCE = 'KMS_INSTANCE_IMG_RESOURCE'    // 实体媒体资源-图像资源

    // 内部组织-组织id
    static orgId = 'a2469a7b2557643a3f3fffca22705782';     // 超级管理员创建知识库时默认关联到内部组织
    
    // 字典标签
    static KGS_FILEID_TYPE_OPTION = 'KGS_FILEID_TYPE_OPTION';  // 表单控件类型字典标签
    static KGS_LIFECYCLE_TYPE_OPTION = 'KGS_LIFECYCLE_TYPE_OPTION';  // 人物生平类型字典标签
    static KGS_THREEDIMENSION_TYPE_OPTION = 'KGS_THREEDIMENSION_TYPE_OPTION';  // 三维数据类型字典标签
    static KGS_DADABASE_DRIVER_OPTION = 'KGS_DADABASE_DRIVER_OPTION';  // 数据库驱动类类型
    static KGS_GRAB_TYPE_OPTION = 'KGS_GRAB_TYPE_OPTION';         // 网络抓取素材类型
    static KGS_UNIT_OPTION =  'KGS_UNIT_OPTION';   // 尺寸单位
    static KGS_MATERIAL_DATA_TYPE = 'kgs_material_data_type_lv_1';   // 素材数据类型  书影、书目、传记、全文
    static KGS_QUESTION_TYPE = 'kgs_question_type_lv_1'              // 错误类型（数据质检）
    static KGS_RELATION_TYPE = 'kgs_relation_type_lv_1'              // 关系类型
    static KGS_MATERIAL_RECORD_TYPE_OPTION = 'kgs_material_record_type_lv_1';  // 素材著录类型（书籍、期刊、报纸等）
    static KGS_IMAGE_TYPE_OPTION = 'KGS_IMAGE_TYPE_OPTION';         // 图像类型
    static KGS_LINKDATA_TYPE_OPTION =  'KGS_LINKDATA_TYPE_OPTION';   // 媒体资源-链接数据类型

    // static Default_Path_Node = {
    //     startNode: '中国共产党第一次全国代表大会',
    //     endNode: '毛泽东'
    // }
    static Default_Path_Node = {
        startNode: '',
        endNode: ''
    }

    // 字段类型值
    static FORM_CONTROL_TYPES = {
        img:"KGS2601",             // 表单控件类型-图片
        input:"KGS2602",           // 表单控件类型-短文本
        dropBox:"KGS2603",        // 表单控件类型-下拉框
        selectBox:"KGS2604",      // 表单控件类型-选择框
        radio:"KGS2605",        // 表单控件类型-单选
        textarea:"KGS2606",        // 表单控件类型-文本框
        richTextBox:"KGS2607",   // 表单控件类型-富文本框
        dateRemark:"KGS2608",     // 表单控件类型-日期（带日期备注）
        date:"KGS2609",            // 表单控件类型-日期（不带日期备注）
        geoRemark:"KGS2610",      // 表单控件类型-地理位置（带位置备注）
        geo:"KGS2611",             // 表单控件类型-地理位置（不带位置备注）
        treeSelect:"KGS2614",  // 表单控件类型-树形下拉框
        nowDate:"KGS2615",  // 现代时间
        administrativeDivision:"KGS2616",  // 行政区划
        richTextMarkBox:"KGS2617"  // 表单控件类型-富文本框(带标注样式)
    }

    // 网页抓取类型
    static crawlTypeOptions = [
        {
          'id': 1,
          'text': '全站抓取'
        },
        {
          'id': 2,
          'text': '关键字抓取'
        }
    ]

    // 资源类型
    static fileTypes = [
        { 
            id: 'FILE_TYPE_DOCUMENT', 
            text: '文档',
            childs: [
                { id: 'BOOK', text: '图书',
                    recordFileds: [
                        {id:'mainResponsiblePerson',text:'主要责任人'},{id:'publishingPlace',text:'出版地'},
                        {id:'publishingHouse',text:'出版社'},{id:'publicationTime',text:'出版时间'},
                        {id:'abstract',text:'摘要'},{id:'remark',text:'备注'}
                    ]
                },
                { id: 'JOURNAL', text: '期刊论文',
                    recordFileds: [
                        {id:'mainResponsiblePerson',text:'主要责任人'},{id:'journalName',text:'期刊名'},
                        {id:'issueVolume',text:'期卷'},{id:'publicationTime',text:'发表时间'},
                        {id:'keyword',text:'关键词'},{id:'abstract',text:'摘要'},{id:'remark',text:'备注'}
                    ]
                },
                { id: 'PAPER', text: '学位论文',
                    recordFileds: [
                        {id:'mainResponsiblePerson',text:'主要责任人'},{id:'degreesType',text:'学位类型'},
                        {id:'orgnization',text:'机构'},{id:'publicationTime',text:'发表时间'},
                        {id:'keyword',text:'关键词'},{id:'abstract',text:'摘要'},{id:'remark',text:'备注'}
                    ]
                },
                { id: 'ANCIENT_BOOK', text: '文物',
                    recordFileds: [
                        {id:'mainResponsiblePerson',text:'主要责任人'},{id:'volumeNumber',text:'卷数'},
                        {id:'edition',text:'版本'},{id:'publishingPlace',text:'出版地'},
                        {id:'publishingHouse',text:'出版社'},{id:'publicationTime',text:'出版时间'},
                        {id:'abstract',text:'摘要'},{id:'remark',text:'备注'}
                    ]
                },
                { id: 'OTHER', text: '其他', 
                    recordFileds: [
                        {id:'mainResponsiblePerson',text:'主要责任人'},{id:'publicationTime',text:'出版时间'},
                        {id:'abstract',text:'摘要'},{id:'remark',text:'备注'}
                    ] 
                }
            ],
            recordFileds: [
                {id:'mainResponsiblePerson',text:'主要责任人'},{id:'publicationTime',text:'出版时间'},
                {id:'abstract',text:'摘要'},{id:'remark',text:'备注'}
            ]
        },
        { 
            id: 'FILE_TYPE_PICTURE', 
            text: '图像',
            childs: [],
            recordFileds: [
                {id:'mainResponsiblePerson',text:'主要责任人'},{id:'publicationTime',text:'发表时间'},
                {id:'sourceCaption',text:'来源题注'},{id:'keyword',text:'关键词'},
                {id:'abstract',text:'摘要'},{id:'remark',text:'备注'}
            ]
        },
        { 
            id: 'FILE_TYPE_AUDIO', 
            text: '音频',
            childs: [],
            recordFileds: [
                {id:'mainResponsiblePerson',text:'主要责任人'},{id:'publicationTime',text:'发表时间'},
                {id:'keyword',text:'关键词'},{id:'abstract',text:'摘要'},
                {id:'text',text:'文本'},{id:'remark',text:'备注'}
            ]
        },
        { 
            id: 'FILE_TYPE_VIDEO', 
            text: '视频',
            childs: [],
            recordFileds: [
                {id:'mainResponsiblePerson',text:'主要责任人'},{id:'publicationTime',text:'发表时间'},
                {id:'keyword',text:'关键词'},{id:'abstract',text:'摘要'},
                {id:'text',text:'文本'},{id:'remark',text:'备注'}
            ]
        },
        { 
            id: 'KGS_LINKDATA', 
            text: '外站链接',
            childs: [
                { id: 'KGS_LINKDATA_IMAGE_TEXT', text: '外站链接（图文）',recordFileds:[]},
                { id: 'KGS_LINKDATA_AUDIO', text: '外站链接（音频）',recordFileds:[]},
                { id: 'KGS_LINKDATA_VIDEO', text: '外站链接（视频）',recordFileds:[]},
                { id: 'KGS_LINKDATA_THREE_DIMENSION', text: '外站链接（三维）',recordFileds:[]},
                { id: 'KGS_LINKDATA_RING_SHOT', text: '外站链接（环拍）',recordFileds:[]},
                { id: 'KGS_LINKDATA_OVERALL_VIEW', text: '外站链接（全景）',recordFileds:[]}
            ],
            recordFileds: [
                {id:'mainResponsiblePerson',text:'主要责任人'},{id:'publicationTime',text:'发表时间'},
                {id:'keyword',text:'关键词'},{id:'abstract',text:'摘要'},
                {id:'text',text:'文本'},{id:'remark',text:'备注'}
            ]
        }
    ]

    // 旧资源类型
    static oldFileTypes = [
        { id: 'FILE_TYPE_DOCUMENT', text: '文档',childs:[],recordFileds:[]},
        { id: 'FILE_TYPE_PICTURE', text: '图像',childs:[],recordFileds:[]},
        { id: 'FILE_TYPE_AUDIO', text: '音频',childs:[],recordFileds:[]},  
        { id: 'FILE_TYPE_VIDEO', text: '视频',childs:[],recordFileds:[]},
        { id: 'KGS_LINKDATA_IMAGE_TEXT', text: '外站链接（图文）',childs:[],recordFileds:[]},
        { id: 'KGS_LINKDATA_AUDIO', text: '外站链接（音频）',childs:[],recordFileds:[]},
        { id: 'KGS_LINKDATA_VIDEO', text: '外站链接（视频）',childs:[],recordFileds:[]},
        { id: 'KGS_LINKDATA_THREE_DIMENSION', text: '外站链接（三维）',childs:[],recordFileds:[]},
        { id: 'KGS_LINKDATA_RING_SHOT', text: '外站链接（环拍）',childs:[],recordFileds:[]},
        { id: 'KGS_LINKDATA_OVERALL_VIEW', text: '外站链接（全景）',childs:[],recordFileds:[]}
    ]

    // 素材内容排版格式
    static docTypeOptions = [
        {
            id:'1',
            text: '横排'
        },
        {
            id:'2',
            text: '竖排'
        },
        {
            id:'3',
            text: '其他'
        }
    ]

    // 词条类别
    static wordTypeList = [
        {
            id: 'r',
            text: '代词',
            isEnable: false
        },
        {
            id: 'n',
            text: '名词',
            isEnable: false
        },
        {
            id: 'Nh',
            text: '人名',
            isEnable: true
        },
        {
            id: 'Ns',
            text: '地名',
            isEnable: true
        },
        {
            id: 'Nt',
            text: '时间',
            isEnable: true
        },
        {
            id: 'Ni',
            text: '机构团体',
            isEnable: true
        },
        {
            id: 'wp',
            text: '标点',
            isEnable: false
        },
        {
            id: 'k',
            text: '后缀',
            isEnable: false
        },
        {
            id: 'h',
            text: '前缀',
            isEnable: false
        },
        {
            id: 'u',
            text: '助词',
            isEnable: false
        },
        {
            id: 'c',
            text: '连词',
            isEnable: false
        },
        {
            id: 'v',
            text: '动词',
            isEnable: false
        },
        {
            id: 'p',
            text: '介词',
            isEnable: false
        },
        {
            id: 'd',
            text: '副词',
            isEnable: false
        },
        {
            id: 'q',
            text: '量词',
            isEnable: false
        },
        {
            id: 'm',
            text: '数词',
            isEnable: false
        },
        {
            id: 'e',
            text: '语气词',
            isEnable: false
        },
        {
            id: 'b',
            text: '状态词',
            isEnable: false
        },
        {
            id: 'a',
            text: '形容词',
            isEnable: false
        },
        {
            id: 'nd',
            text: '方位词',
            isEnable: false
        },
        {
            id: 'nl',
            text: '处所词',
            isEnable: false
        },
        {
            id: 'o',
            text: '拟声词',
            isEnable: false
        },
        {
            id: 'nt',
            text: '时间词',
            isEnable: false
        },
        {
            id: 'nz',
            text: '其他专名',
            isEnable: false
        },
        {
            id: 'i',
            text: '成语',
            isEnable: false
        },
        {
            id: 'j',
            text: '缩写词',
            isEnable: false
        },
        {
            id: 'ws',
            text: '外来词',
            isEnable: false
        },
        {
            id: 'g',
            text: '词素',
            isEnable: false
        },
        {
            id: 'x',
            text: '非词位',
            isEnable: false
        },
        {
            id: 'z',
            text: '形容词',
            isEnable: false
        },
        {
            id: '%',
            text: '未知词性',
            isEnable: false
        }
    ]

    static colorConfig = {
        '文物': 'rgb(255, 138, 69)',
        '历史事件': 'rgb(253, 221, 96)',
        '典故轶事': 'rgb(72, 144, 252)',
        '人物': 'rgb(221,121,255)',
        '组织机构': 'rgb(255, 110, 118)',
        '政策制度': 'rgb(166, 130, 48)',
        '地名': 'rgb(30, 255, 30)',
        '作品': 'rgb(41, 135, 141)',
        '文书档案': 'rgb(199, 252, 160)',
        '思想学说': 'rgb(46, 155, 96)',
        '术语': 'rgb(166, 69, 13)',
        '时间': 'rgb(150, 150, 199)',
        '数字资源': 'rgb(244, 19, 183)'
    }

    // 图谱分类概念颜色
    static mapColors = [
        {bg: '#a2d7dd', br: 'rgba(162, 215, 221, 0.6)', text: '#ffffff'},
        {bg: '#abced8', br: 'rgba(171, 206, 216, 0.6)', text: '#ffffff'},
        {bg: '#bbbcde', br: 'rgba(187, 188, 222, 0.6)', text: '#ffffff'},
        {bg: '#bbc8e6', br: 'rgba(187, 200, 230, 0.6)', text: '#ffffff'},
        {bg: '#bce288', br: 'rgba(188, 226, 136, 0.6)', text: '#ffffff'},
        {bg: '#00a3af', br: 'rgba(0, 163, 175, 0.6)', text: '#ffffff'},
        {bg: '#00a381', br: 'rgba(0, 163, 129, 0.6)', text: '#ffffff'},
        {bg: '#00a497', br: 'rgba(0, 164, 151, 0.6)', text: '#ffffff'},
        {bg: '#007bbb', br: 'rgba(0, 123, 187, 0.6)', text: '#ffffff'},
        {bg: '#008899', br: 'rgba(0, 136, 153, 0.6)', text: '#ffffff'},
        {bg: '#0094c8', br: 'rgba(0, 148, 200, 0.6)', text: '#ffffff'},
        {bg: '#2a83a2', br: 'rgba(42, 131, 162, 0.6)', text: '#ffffff'},
        {bg: '#2792c3', br: 'rgba(39, 146, 195, 0.6)', text: '#ffffff'},
        {bg: '#3e62ad', br: 'rgba(62, 98, 173, 0.6)', text: '#ffffff'},
        {bg: '#38b48b', br: 'rgba(56, 180, 139, 0.6)', text: '#ffffff'},
        {bg: '#4c6cb3', br: 'rgba(76, 108, 179, 0.6)', text: '#ffffff'},
        {bg: '#478384', br: 'rgba(71, 131, 132, 0.6)', text: '#ffffff'},
        {bg: '#5a79ba', br: 'rgba(90, 121, 186, 0.6)', text: '#ffffff'},
        {bg: '#5c9291', br: 'rgba(92, 146, 145, 0.6)', text: '#ffffff'},
        {bg: '#5383c3', br: 'rgba(83, 131, 195, 0.6)', text: '#ffffff'},
        {bg: '#59b9c6', br: 'rgba(89, 185, 198, 0.6)', text: '#ffffff'},
        {bg: '#698aab', br: 'rgba(105, 138, 171, 0.6)', text: '#ffffff'},
        {bg: '#80aba9', br: 'rgba(128, 171, 169, 0.6)', text: '#ffffff'},
        {bg: '#83ccd2', br: 'rgba(131, 204, 210, 0.6)', text: '#ffffff'},
        {bg: '#84a2d4', br: 'rgba(132, 162, 212, 0.6)', text: '#ffffff'},
        {bg: '#84b9cb', br: 'rgba(132, 185, 203, 0.6)', text: '#ffffff'},
        {bg: '#89c3eb', br: 'rgba(137, 195, 235, 0.6)', text: '#ffffff'},
        {bg: '#a0d8ef', br: 'rgba(160, 216, 239, 0.6)', text: '#ffffff'},
        {bg: '#c1e4e9', br: 'rgba(193, 228, 233, 0.6)', text: '#ffffff'},
    ]
}